import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const Cpms = ({ fieldData, setFieldData, formErrors, setFormErrors }) => {
  useEffect(() => {
    return () => {
      setFieldData(previousValue => ({ ...previousValue, cpmsId: '' }));
    };
  }, []);

  return (
    <TextInput
      type="tel"
      label="CPMS ID *"
      maxLength="4"
      value={fieldData.cpmsId}
      error={'cpmsId' in formErrors ? formErrors.cpmsId.message : undefined}
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            cpmsId: { message: 'Field is required' }
          });
        else if (!/^[0-9|a-z|A-Z]{4}/.test(value)) {
          setFormErrors({
            ...formErrors,
            cpmsId: { message: 'Cpms Id must be exactly 4 digit' }
          });
        } else {
          const errors = { ...formErrors };
          delete errors.cpmsId;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          cpmsId: value
        }));
      }}
    />
  );
};

Cpms.propTypes = {
  formErrors: PropTypes.shape({
    cpmsId: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default Cpms;
